import { render, staticRenderFns } from "./canteen.vue?vue&type=template&id=2054b1ba&scoped=true&"
import script from "./canteen.vue?vue&type=script&lang=js&"
export * from "./canteen.vue?vue&type=script&lang=js&"
import style0 from "./canteen.vue?vue&type=style&index=0&id=2054b1ba&scoped=true&lang=css&"
import style1 from "./canteen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2054b1ba",
  null
  
)

export default component.exports